import generateSequence from 'helpers/generateSequence';

export const rentOptions = [
  { key: '', value: 'Any' },
  ...generateSequence(
    {
      0: 100,
      1000: 250,
      3000: 500,
      5000: 1000,
      10000: 2500,
      20000: 5000,
    },
    100,
    40_000
  ).map((v) => ({
    key: v,
    value: `£${v}`,
  })),
];

export const bedroomOptions = [
  ...new Array(7).fill(0).map((i, idx) => ({ key: idx + 1, value: idx + 1 })),
  { key: 8, value: '8+' },
];

export const typeOptions = [
  { key: 'detachedHouse', value: 'Detached House' },
  { key: 'studio', value: 'Studio' },
  { key: 'semiDetachedHouse', value: 'Semi Detached House' },
  { key: 'flat', value: 'Flat' },
  { key: 'terracedHouse', value: 'Terraced House' },
  { key: 'bungalow', value: 'Bungalow' },
];

export const furnishingOptions = [
  { key: 'unfurnished', value: 'Unfurnished' },
  { key: 'partFurnished', value: 'Part Furnished' },
  { key: 'furnished', value: 'Furnished' },
];

export const featuresOptions = [
  { key: 'billsIncluded', value: 'Bills Included' },
  { key: 'cellar', value: 'Cellar' },
  { key: 'conservatory', value: 'Conservatory' },
  { key: 'disabledAccess', value: 'Disabled Access' },
  { key: 'dishwasher', value: 'Dishwasher' },
  { key: 'diningRoom', value: 'Dining Room' },
  { key: 'fireplace', value: 'Fireplace' },
  { key: 'gym', value: 'Gym' },
  { key: 'leisureFacilities', value: 'Leisure Facilities' },
  { key: 'livingRoom', value: 'Living Room' },
  { key: 'newlyBuilt', value: 'Newly Built' },
  { key: 'petFriendly', value: 'Pet Friendly' },
  { key: 'topFloor', value: 'Top Floor' },
  { key: 'washingMachine', value: 'Washing Machine' },
  { key: 'waterfront', value: 'Waterfront' },
  { key: 'woodenFloors', value: 'Wooden Floors' },
];

export const outsideSpaceOptions = [
  { key: 'balcony', value: 'Balcony' },
  { key: 'communalGarden', value: 'Communal Garden' },
  { key: 'privateGarden', value: 'Private Garden' },
  { key: 'terrace', value: 'Terrace' },
];

export const parkingOptions = [
  { key: 'singleGarage', value: 'Single Garage' },
  { key: 'doubleGarage', value: 'Double Garage' },
  { key: 'street', value: 'Street' },
  { key: 'singleSpace', value: 'Single Space' },
  { key: 'doubleSpace', value: 'Double Space' },
  { key: 'noParking', value: 'No Parking' },
];

export const dateAddedOptions = [
  { key: '1', value: 'Last 24 Hours' },
  { key: '3', value: 'Last 3 days' },
  { key: '7', value: 'Last 7 days' },
  { key: '14', value: 'Last 14 days' },
];

const square = 0.06;
// const fixLocationStr = (v) => `${v}`.replace(/[0]+[1-9]$/, '');

export const map = {
  location: {
    toFilter: (l) => {
      let lngMin;
      let lngMax;
      let latMin;
      let latMax;
      // 'addressLat <= 51.540328335846546 AND addressLat >= 51.5080247350025 AND addressLong <= -0.06632985428452971 AND addressLong >= -0.09514674571548376',
      if (l.bounds) {
        lngMin = l.bounds.lngMin;
        lngMax = l.bounds.lngMax;
        latMin = l.bounds.latMin;
        latMax = l.bounds.latMax;
      } else {
        lngMin = l.lng - square;
        lngMax = l.lng + square;
        latMin = l.lat - square;
        latMax = l.lat + square;
      }

      return `address_lat <= ${latMax} AND address_lat >= ${latMin} AND address_long <= ${lngMax} AND address_lat >= ${lngMin}`;
    },
  },
  tenancyRentAmountMin: {
    options: rentOptions,
    toFilter: (v) => `tenancy_rent_amount >= ${v}`,
  },
  tenancyRentAmountMax: {
    options: rentOptions,
    toFilter: (v) => `tenancy_rent_amount <= ${v}`,
  },
  bedroomCount: {
    options: bedroomOptions,
    toFilter: (arr) =>
      arr
        .map((i) => `bedroom_count ${i * 1 === 8 ? '>= 8' : `= ${i}`}`)
        .join(' OR '),
  },
  bathroomCount: {
    options: bedroomOptions,
    toFilter: (arr) =>
      arr
        .map((i) => `bathroom_count ${i * 1 === 8 ? '>= 8' : `= ${i}`}`)
        .join(' OR '),
  },
  propertyType: {
    options: typeOptions,
    toFilter: (arr) => arr.map((i) => `property_type = ${i}`).join(' OR '),
  },
  propertyFurnishing: {
    options: furnishingOptions,
    toFilter: (arr) =>
      arr.map((i) => `property_furnishing = ${i}`).join(' OR '),
  },
  propertyFeatures: {
    options: featuresOptions,
    toFilter: (arr) => arr.map((i) => `property_features = ${i}`).join(' AND '),
  },
  propertyOutsideSpace: {
    options: outsideSpaceOptions,
    toFilter: (arr) =>
      arr.map((i) => `property_outside_spaces = ${i}`).join(' OR '),
  },
  propertyParking: {
    options: parkingOptions,
    toFilter: (arr) => arr.map((i) => `property_parking = ${i}`).join(' OR '),
  },
  dateAdded: {
    options: dateAddedOptions,
    toFilter: (v) => {
      const date = new Date();
      const ms = v * 24 * 60 * 60 * 1000;
      const computedDate = date.getTime() - ms;

      return `date_updated >= ${computedDate}`;
    },
  },
};

export const filterObjToStr = (filter) =>
  Object.keys(filter)
    .reduce((acc, key) => {
      if (map[key]) {
        return [...acc, map[key].toFilter(filter[key])];
      }

      return acc;
    }, [])
    .join(' AND ');
